import { h, Fragment, Component, Host, forceUpdate } from '@stencil/core';
import state, { store } from '../../state';
import { getViewportValue } from '../../utils';

@Component({
  tag: 'om-bg-images',
  styleUrl: './bg-images.css',
  scoped: true,
})
export class BgImages {
  render() {
    // Safety guard: Mini overlay doesn't have background field
    if (state.currentScreen === 'miniOverlay') {
      return null;
    }

    const currentScreenValues = state.content[state.currentScreen];
    const nextScreenValues = state.content[state.nextScreen];

    return (
      <Host
        style={{
          '--bg-color': getViewportValue(currentScreenValues.background, 'colour'),
          '--bg-img': `url(${CSS.escape(getViewportValue(currentScreenValues.background, 'imageUrl'))})`,
          'height': '100%',
          'width': '100%',
          ...(nextScreenValues && {
            '--bg-next-img': `url(${CSS.escape(getViewportValue(nextScreenValues.background, 'imageUrl'))})`,
          }),
        }}
      >
        <img
          class="visually-hidden"
          id="om_overlay_a11y_img"
          src={getViewportValue(currentScreenValues.background, 'imageUrl')}
          alt={getViewportValue(currentScreenValues.background, 'imageAltText')}
        />
        {nextScreenValues && (
          <Fragment>
            <img
              class="visually-hidden"
              id="om_overlay_a11y_img"
              src={getViewportValue(nextScreenValues.background, 'imageUrl')}
              alt={getViewportValue(nextScreenValues.background, 'imageAltText')}
            />
            <div class="next-screen-background" />
          </Fragment>
        )}
        <div
          class={state.isMobileViewport ? 'current-screen-background is-mobile-viewport' : 'current-screen-background'}
        />
      </Host>
    );
  }

  componentWillRender() {
    if (state.mode !== 'preview') return;
    store.onChange('content', () => forceUpdate(this));
    store.onChange('currentScreen', () => forceUpdate(this));
  }
}
